// extracted by mini-css-extract-plugin
module.exports = {"reactPlayer":"VideoPlayer_reactPlayer__E9xdL","videoIcon":"VideoPlayer_videoIcon___2fMw","thumbnail":"VideoPlayer_thumbnail__4QHwW","play":"VideoPlayer_play__rhQep"};